<template>
    <div  v-if="currentLang=='zh'">
        <img :src="CompanyInfo.esgTopMobileImg" style="width:calc(100% - 0px);">
        <img :src="CompanyInfo.environmentalMobileImg" style="width:calc(100% - 0px);">
        <img :src="CompanyInfo.societyMobileImg" style="width:calc(100% - 0px);">
        <img :src="CompanyInfo.companyGovernanceMobileImg" style="width:calc(100% - 0px);">
    </div>
    <div v-else>
        <img :src="CompanyInfo.esgTopMobileImgEn" style="width:calc(100% - 0px);">
        <img :src="CompanyInfo.environmentalMobileImgEn" style="width:calc(100% - 0px);">
        <img :src="CompanyInfo.societyMobileImgEn" style="width:calc(100% - 0px);">
        <img :src="CompanyInfo.companyGovernanceMobileImgEn" style="width:calc(100% - 0px);">
    </div>
</template>
<script>
import {mapState} from 'vuex'
import WOW from "../../../node_modules/wowjs/dist/wow";
export default {
  data() {
    return {
      contactList:[],
      current_index:0,
      currentLang:this.$i18n.locale
    }
  },
  computed:{
    ...mapState({
      CompanyInfo:state=>state.CompanyInfo
    })
  },
  created: function () {
      this.HandleInfo();
  },
  mounted() {
    //滚动页面加载动画
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
  
  },
  components: {
    
  },
  methods: {
     HandleInfo(){
      if (this.CompanyInfo.contactList){
        this.contactList = JSON.parse(this.CompanyInfo.contactList);
      }
     },
     ClickMap(item,index){
      this.current_index=index;
     }
  },
  watch:{
    CompanyInfo(){
      this.HandleInfo();
    }
  }
};
</script>
